export enum NotificationCategory {
  'thread' = 'thread',
  'invoice' = 'invoice',
  'file' = 'file',
}
